module.exports = __webpack_public_path__ + "img/login_title.87f29ac2.png";